"use client";
import {
  CompositeContextProvider,
  CompositeScopedContextProvider
} from "./X3ATWMYX.js";
import {
  HovercardContextProvider,
  HovercardScopedContextProvider
} from "./B4BLW6E7.js";
import {
  createStoreContext
} from "./LFJDOMBA.js";

// src/menu/menu-context.ts
import { createContext } from "react";
var menu = createStoreContext(
  [CompositeContextProvider, HovercardContextProvider],
  [CompositeScopedContextProvider, HovercardScopedContextProvider]
);
var useMenuContext = menu.useContext;
var useMenuScopedContext = menu.useScopedContext;
var useMenuProviderContext = menu.useProviderContext;
var MenuContextProvider = menu.ContextProvider;
var MenuScopedContextProvider = menu.ScopedContextProvider;
var menubar = createStoreContext(
  [CompositeContextProvider],
  [CompositeScopedContextProvider]
);
var useMenuBarContext = menubar.useContext;
var useMenuBarScopedContext = menubar.useScopedContext;
var useMenuBarProviderContext = menubar.useProviderContext;
var MenuBarContextProvider = menubar.ContextProvider;
var MenuBarScopedContextProvider = menubar.ScopedContextProvider;
var MenuItemCheckedContext = createContext(
  void 0
);

export {
  useMenuContext,
  useMenuScopedContext,
  useMenuProviderContext,
  MenuContextProvider,
  MenuScopedContextProvider,
  useMenuBarContext,
  useMenuBarScopedContext,
  useMenuBarProviderContext,
  MenuBarContextProvider,
  MenuBarScopedContextProvider,
  MenuItemCheckedContext
};
